<template>
  <div class="pendingorder">
    <div style="font-size:18px;font-weight:bold;margin-bottom:20px">
      {{ $t('homeTwo.ToCheck') }}
      <!-- <span @click="cnage()">{{msg}}</span> -->
    </div>
    <!-- <div style="text-align:center;height:100vh;line-height:80vh" v-if="!shophasAuthorization">
			<div style="color:#606266" >{{$t("other.a891")}}
				<router-link style="color:red;text-decoration:none" :to="{name:'index'}">{{$t("other.a892")}}</router-link>
			</div>
    </div>-->
    <div>
      <Dialog :showAppDia.sync="showAppDia"></Dialog>
      <!-- 产品分类弹窗 -->
      <Dialog :bulletframe.sync="bulletframe" :productfenlei="productfenlei"></Dialog>
      <Dialog :reloadorder.sync="reloadorder"></Dialog>
      <!-- 修改订单信息 -->
      <Customer-Order :showCustomerPop.sync="showCustomerPop" :listData="listData"
        @updataOrderItem="updataOrderItem"></Customer-Order>
      <!-- 修改绑定 -->
      <Customer-Order :bindOrder.sync="bindOrder" :textDesc="textDesc"
        @updataItem="updataItem(arguments)"></Customer-Order>
      <!-- 变换失败弹窗 -->
      <el-dialog :title="$t('other.a678')" :visible.sync="massCreateOrderDia" :close-on-click-modal="false" width="30%">
        <div class="modleDownload">
          <a style="color:red" href="https://erp.shopsbu.com/shopOrder/downloadDxsOrderExcelFile">{{ $t('other.a679')
          }}</a>
        </div>

        <div class="massCreateWrapper">
          <el-upload class="image-uploader" :multiple="false" :auto-upload="true" list-type="text" action
            :before-upload="beforeUpload" :show-file-list="true" :limit="1" :http-request="uploadFile"
            :on-exceed="handleExceed">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{ $t('other.a680') }}</div>
          </el-upload>
        </div>
        <div class="masscreateTip" v-show="loadingTip == 1">
          <i class="el-icon-loading"></i>
          {{ $t('other.a681') }}
        </div>
        <div class="masscreateTip" v-show="loadingTip == 2">{{ $t('other.a682') }}</div>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" @click="massCreateOrderDia = false">{{ $t('other.a106') }}</el-button>
          <el-button type="primary" @click="massCreateOrderDia = false">{{ $t('other.a274') }}</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="$t('other.a676')" :visible.sync="bindError" width="70%">
        <div>
          <el-table :data="errorList" style="width: 100%;">
            <el-table-column prop="date" :label="$t('other.a657')" width="60">
              <template slot-scope="scope">
                <span class="pic">
                  <img :src="scope.row.image" />
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="date" :label="$t('other.a677')">
              <template slot-scope="scope">
                <span>{{ scope.row.msg }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="bindError = false">{{ $t('other.a5') }}</el-button>
        </span>
      </el-dialog>
      <!-- 自动审核弹窗 -->
      <el-dialog :title="$t('pendingorder.Turn_on')" :visible.sync="autoAudit" width="70%">
        <div>
          <el-table :data="autoReviesList" style="width: 100%;">
            <el-table-column prop="shopName" :label="$t('pendingorder.Store_Name')"
              :show-overflow-tooltip="true"></el-table-column>
            <el-table-column :label="$t('pendingorder.warehouse')" :show-overflow-tooltip="true" width="200">
              <template slot-scope="scope">
                <el-select size="mini" style="width: 120px;" @change="checkWarehouseType(scope.row.storeId)"
                  v-model="scope.row.storeId" :placeholder="$t('pendingorder.warehouse')">
                  <el-option v-for="item in autoReviewWarehouse" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column :label="$t('pendingorder.un_include')" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isVerify" :active-text="$t('pendingorder.yes')"
                  :inactive-text="$t('pendingorder.no')"></el-switch>
              </template>
              <template slot="header">
                <el-tooltip effect="light" :content="$t('other.a656')" placement="top">
                  <span>
                    {{ $t('pendingorder.un_include') }}
                    <i class="el-icon-question" style="font-size:22px"></i>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column :label="$t('pendingorder.auto_distribute')" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span v-if="!scope.row.ruleId && !scope.row.isOpen" style="color:#409EFF;margin:0 5px;cursor: pointer;"
                  @click="saveAutoRevies(scope.row)">{{ $t('pendingorder.open') }}</span>
                <span v-if="scope.row.ruleId || scope.row.isOpen" style="color:#409EFF;margin:0 5px;cursor: pointer;"
                  @click="saveAutoRevies(scope.row)">{{ $t('pendingorder.Turned_on') }}</span>
                <span v-if="scope.row.ruleId || scope.row.isOpen" style="color:#409EFF;margin:0 5px;cursor: pointer;"
                  @click="closeAutoRevies(scope.row)">{{ $t('pendingorder.shut_down') }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="isAutoAudit">{{ $t('pendingorder.confirm') }}</el-button>
        </span>
      </el-dialog>

      <el-dialog :title="$t('other.a685')" :visible.sync="orderDetailDia" width="80%">
        <div class="orderDetailDia">
          <div>
            <div style="text-align: center;color: rgb(42, 165, 21);">
              <i class="iconfont icon-gouSolid-copy"></i>
              {{ $t('other.a684') }}（{{ success_data.length }}）
            </div>
            <el-table :data="success_data" style="width: 550px;" height="300">
              <el-table-column prop="orderId" :label="$t('homeTwo.SubInspection')"></el-table-column>
              <el-table-column prop="msg" :label="$t('userStoreItems.Prompt')"></el-table-column>
              <el-table-column prop="fee" :label="$t('homeTwo.Preemptivepoints')"></el-table-column>
            </el-table>
          </div>
          <div>
            <div style="text-align: center;color:rgb(255, 164, 61);">
              <i class="iconfont icon-jinggao"></i>
              {{ $t('other.a687') }}（{{ error_data.length }}）
            </div>
            <el-table :data="error_data" style="width: 550px;" height="300">
              <el-table-column prop="orderId" :label="$t('homeTwo.SubInspection')"></el-table-column>
              <el-table-column prop="msg" :label="$t('userStoreItems.Prompt')"></el-table-column>
              <el-table-column prop="fee" :label="$t('homeTwo.Preemptivepoints')"></el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="orderDetailDia = false">{{ $t('allorders.Isee') }}</el-button>
        </span>
      </el-dialog>
      <!-- 批量审核弹窗 -->
      <el-dialog :title="$t('pendingorder.select')" :visible.sync="dialogVisible01" width="1200px">
        <div style="display:flex;align-items: center;">
          <!-- {{warehouseValue == '' ?$t('other.a354')  :showStoreNameById(warehouseValue)}} -->
          <span style="font-size:18px;color:red;margin-left:10px">{{ $t('allorders.Therepository') }}：</span>
          <el-select class="country-choose" @change="Review" v-model="warehouseValue"
            :placeholder="$t('pendingorder.select')">
            <el-option v-for="item in warehouselist" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>

          <div v-show="goodsVisable">
            <span style="font-size:18px;color:red;margin-left:10px">{{ $t('allorders.typegoods') }}：</span>
            <el-select v-model="goodsType" :placeholder="$t('allorders.warehouse')">
              <el-option v-for="item in goodsOption" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
        <div style="text-align: center;margin: 10px; 0">{{ $t('pendingorder.oop') }}</div>
        <div style="display: flex;justify-content: space-between;">
          <div>
            <div style="text-align: center;color: rgb(42, 165, 21);">
              <i class="iconfont icon-gouSolid-copy"></i>
              {{ $t('pendingorder.llo') }}：({{ auditOrder_success.length }})
            </div>
            <div>
              <el-table :data="auditOrder_success" style="width: 550px;" height="300">
                <el-table-column prop="orderId" :label="$t('pendingorder.ggo')"></el-table-column>
                <el-table-column prop="shipByDate" :label="$t('pendingorder.hho')" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span>{{ getTime01(scope.row.shipByDate) }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="storeType == 0" :show-overflow-tooltip="true">
                  <template slot-scope="scope" slot="header">
                    <span style="padding-right:5px">{{ $t('allorders.pastesheet') }}</span>
                    <el-checkbox @change="tarGetAllServicd(0)" v-model="checkedService">{{ $t('allorders.Batchopen')
                    }}</el-checkbox>
                  </template>
                  <template slot-scope="scope">
                    <el-switch v-model="scope.row.service" active-text="否" in:active-text="$t('other.a191')"></el-switch>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div>
            <div style="text-align: center;color:rgb(255, 164, 61);">
              <i class="iconfont icon-jinggao"></i>
              {{ $t('pendingorder.pkl') }}：({{ auditOrder_error.length }})
            </div>
            <el-table :data="auditOrder_error" style="width: 550px;" height="300">
              <el-table-column prop="orderId" :label="$t('pendingorder.ggo')"></el-table-column>
              <el-table-column prop="shipByDate" :label="$t('allorders.cause')" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.messageToSeller }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="storeType == 0" :show-overflow-tooltip="true">
                <template slot-scope="scope" slot="header">
                  <span style="padding-right:5px">{{ $t('allorders.pastesheet') }}</span>
                  <el-checkbox @change="tarGetAllServicd(1)" v-model="checkedServiceTwo">{{ $t('allorders.Batchopen')
                  }}</el-checkbox>
                </template>
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.service" :active-text="$t('pendingorder.no')"
                    :inactive-text="$t('pendingorder.yes')"></el-switch>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer reviveOrder">
          <div>
            <!-- v-show="storeType == 2" -->
            <el-button type="primary" v-show="storeType == 2" @click="revieworders(1)">{{ $t('pendingorder.iio')
            }}</el-button>
          </div>
          <div>
            <el-button type="primary" @click="cancelReview">{{ $t('pendingorder.cancel') }}</el-button>
            <el-button type="primary" @click="revieworders(0)">{{ $t('pendingorder.uuo') }}</el-button>
          </div>
        </span>
      </el-dialog>

      <!-- 同步商品链接 -->
      <el-dialog :title="$t('other.a3372')" :visible.sync="synchronizeProductsShow" key="itemKey" width="30%">
        <div>
          <div class="ipt" style="display: flex;align-items: center;">
            <div class="iptText" style="width: 60px;">店铺：</div>
            <el-select v-model="synchronizeProductsCheck" placeholder="请选择">
              <el-option v-for="item in synchronizeProductsArr" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="ipt" style="display: flex;align-items: center;flex-wrap: wrap;margin-top: 10px;"
            v-if="synchronizeProductsStatus == 2">
            <div class="iptText" style="margin-bottom: 10px;">请输入需要同步平台的SKCID列表：</div>
            <el-input type="textarea" :rows="4" placeholder="请输入需要同步平台的SKCID列表" v-model="synchronizeProductsSKC">
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="synchronizeProductsShow = false">{{ $t('other.a5') }}</el-button>
          <el-button type="primary" @click="synchronizeProducts()">{{ $t('other.a38') }}</el-button>
        </span>
      </el-dialog>

      <div class="condition_box">
        <condition :ConditionOption="ConditionOption" @getOrderParams="getOrderParams"
          @getOrderParamsCopy="getOrderParamsCopy"></condition>
        <div>
          {{ $t('other.a762') }}：
          <el-switch v-model="userLimited" @change="updataUserLimit()" :active-text="$t('other.a763')"
            :inactive-text="$t('other.a5')"></el-switch>
        </div>
        <div style="display:flex;align-items:center;margin-top:15px">
          <div>
            <span>{{ $t('allorders.Orderfind') }}：</span>
            <el-input size="small" style="width:250px;margin:0 8px " @change="searchOrder()"
              :placeholder="$t('allorders.lookup')" v-model="params.orderId" clearable></el-input>
            <el-button type="primary" size="small">{{ $t('allorders.find') }}</el-button>
          </div>
          <div style="margin-left:20px">
            <span>{{ $t('homeTwo.Filtertoshoworhideorders') }}：</span>
            <el-select v-model="hidden" :placeholder="$t('allorders.pleasechoose')" @change="getHiddenOrder()">
              <el-option key="null" :label="$t('allorders.all')" value="null"></el-option>
              <el-option key="1" :label="$t('allorders.show')" value="1"></el-option>
              <el-option key="2" :label="$t('allorders.hide')" value="2"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <!-- 审核订单，同步订单，自动审核，产品分类 -->
      <div class="btn-box">
        <!-- {{$t('other.a696')}} -->
        <span>
          <el-button style="margin-left: 10px;" type="primary" @click="commitRevies">{{
            $t('pendingorder.Mass_review_orders') }}</el-button>
        </span>
        <!-- 自动审核订单 -->
        <el-tooltip effect="light" :content="$t('allorders.can')" placement="bottom">
          <el-button style="margin-left: 10px;" type="primary" @click="autoAuditrule">{{
            $t('pendingorder.auto_distribute') }}</el-button>
        </el-tooltip>
        <el-dropdown style="margin-left: 10px;">
          <span class="el-dropdown-link">
            <el-button type="primary">{{ $t('pendingorder.synchronize') }}</el-button>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="Synchronize(0)">
              <span>{{ $t('pendingorder.last_3_days') }}</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="Synchronize(1)">
              <span>{{ $t('pendingorder.last_7_days') }}</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="Synchronize(2)">
              <span>{{ $t('pendingorder.last_1_month') }}</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="Synchronize(3)">
              <span>{{ $t('pendingorder.last_3_month') }}</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="reloadorder = true">
              <span>{{ $t('allorders.Synchronizingorder') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="opeartion_btn">
          <!-- <el-button type="primary" @click="synchronizeProducts()">{{ $t('other.a3372')
        }}</el-button> -->
          <el-dropdown>
            <el-button style="margin-left：10px;" size="medium" type="primary">
              {{
                $t('other.a3372')
              }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="synchronizeProductsOpen(1)">同步单店铺</el-dropdown-item>
              <el-dropdown-item @click.native="synchronizeProductsOpen(2)">同步指定SKC</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-button style="margin-left: 10px;" type="primary" @click="extportOrderInfo()">{{
            $t('homeTwo.Batchexportorders') }}</el-button>
        </div>
        <!-- <div><el-button   style="margin-left: 10px;"  type="primary" @click="createNewOrder()">{{$t('allorders.manualorder')}}</el-button></div> -->
        <el-dropdown style="margin-left: 10px;">
          <span class="el-dropdown-link">
            <el-button type="primary">{{ $t('allorders.manualorder') }}</el-button>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="createNewOrder(0)">
              <span>{{ $t('other.a791') }}</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="massCreateOrderDia = true">
              <span>{{ $t('other.a703') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- <el-upload style="margin-left: 8px;"
				class="upload-demo inline-block margin-right-10"
				action=""
				:on-change="handleChange"
				:show-file-list="false"
				:http-request="uploadFile"
				accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
				:auto-upload="false">
				<el-button  type="primary">excel导入创建手工单</el-button>
        </el-upload>-->

        <div class="colng" @click="showAppDia = true" v-if="!isShopsooo">
          <i class="iconfont icon-shoujiduan tubiao"></i>
          <span>{{ $t('other.a704') }}</span>
          <el-tooltip class="item" effect="dark" :content="$t('other.a705')" placement="top-start">
            <i class="el-icon-question oook"></i>
          </el-tooltip>
        </div>
        <!-- <div v-if="userId == '513020778@qq.com'"><el-button   style="margin-left: 10px;"  type="primary" @click="resetOrder()">重置当前店铺的所有订单</el-button></div> -->
      </div>
      <!-- 全选当前面--分页器 -->
      <div class="order-wrapper">
        <div class="checkallbox">
          <div class="checkallbox-left">
            <span style="padding-left: 5px;">
              <el-checkbox v-model="checkall" @change="checkAll">{{ $t('pendingorder.allcurrentpage') }}({{
                targetList.length }})</el-checkbox>
            </span>
          </div>
        </div>
        <div>
          <div class="nodata" v-if="!allOrderList.length && shopeeIdvlue !== -1 && shophasAuthorization">
            <div>
              <i class="iconfont icon-zanwudingdan okng"></i>
            </div>
            <div class="ilnkg">{{ $t('pendingorder.nodata') }}</div>
          </div>
          <!-- 订单详情区域 -->

          <div style="margin-bottom: 50px;" v-else>
            <div class="order-list-item" v-for="(item, index) in allOrderList" :key="index">
              <div class="list-desc">
                <el-checkbox class="chekbox" v-if="checkBox" v-model="item.checked"></el-checkbox>
                <el-tooltip v-if="item.amend" effect="light" :content="$t('allorders.modified')" placement="bottom">
                  <i class="iconfont icon-sign"></i>
                </el-tooltip>

                <el-tooltip v-if="item.storeFlagId" effect="light" :content="item.storeFlagDes" placement="bottom">
                  <i class="iconfont icon-tuihuo2"></i>
                </el-tooltip>

                <span class="seller">{{ $t('pendingorder.orderSn') }}：{{ item.orderId }}</span>
                <span class="seller seller-item">
                  {{ $t('homeTwo.Orderactuallypaid') }}：
                  <span class="seller-ppc">{{ item.escrowAmount }}</span>
                </span>
                <span class="seller seller-item">
                  {{ $t('pendingorder.status') }}：
                  <span class="seller-ppc">{{ getStatus(item) }}</span>
                </span>
                <span class="seller seller-item" v-if="!item.cod && item.platform ==" SHOPEE"">{{ $t('lazada.time') }}：{{
                  getTime(item.createTime) }}</span>
                <span class="seller seller-item" v-if="item.cod">
                  {{ $t('unprocessedorder.paytime') }}：
                  <i style="color:red">{{ $t('allorders.payondelivery') }}</i>
                </span>
                <span class="seller seller-item">
                  {{ $t('pendingorder.delivery_time') }}：
                  <span class="seller-ppc">{{ countTime(item) }}</span>
                </span>
                <span v-show="item.platform !== 'LAZADA'" class="seller seller-item">
                  {{ $t('pendingorder.cancelTime') }}：
                  <span class="seller-ppc">{{ cancelBySystem(item.shipByDate) }}</span>
                </span>
              </div>
              <div class="return-desc">
                <div :class="{ 'return-item': true }">
                  <div class="return-wrpaer">
                    <div class="return-item-list" :class="{ 'unfold': active !== index }"
                      v-for="(ttp, index01) in item.items" :key="index01">
                      <span class="pic-box">
                        <img v-image-preview :src="ttp.attributeImage ? ttp.attributeImage : ttp.image" />
                      </span>
                      <div class="pic-box-desc">
                        <div class="pic-box-desc-item" v-if="item.platform =='TIKTOK'">{{ ttp.variationSku }} / Label size: {{ ttp.variationName }} | {{ ttp.itemName }}</div>
                        <div class="pic-box-desc-item" v-else>{{ ttp.itemName }}</div>

                        <div v-if="ttp.storeItem">
                          <div class="pic-box-desc-amount">{{ $t('other.a566') }}：{{ ttp.storeItem.storeName }}</div>
                          <div class="pic-box-desc-amount">cusCode：{{ ttp.storeItem.cusCode }}（{{ ttp.storeItem.component
                            ?
                            $t('allorders.item') : $t('allorders.setmeal') }}）</div>
                          <div style="margin-top: 5px;font-size:15px"
                            v-if="ttp.storeItem.children !== null && !ttp.storeItem.component">
                            <div style="color:red" v-for="(childre, indexTBB) in ttp.storeItem.children" :key="indexTBB">
                              {{ $t('allorders.theitem') }}({{ childre.cusCode }})：{{ childre.skuName }}
                              {{ $t('allorders.quantity') }}：{{ childre.rate * ttp.variationQuantityPurchased }}</div>
                          </div>
                          <div style="font-size:15px" v-if="ttp.storeItem.children == null">
                            <div style="color:red">sku：{{ ttp.storeItem.skuName }}
                              {{ $t('allorders.quantity') }}：{{ ttp.variationQuantityPurchased }}</div>
                            <div>skuName：{{ ttp.variationName }}</div>
                          </div>
                          <div v-if="ttp.storeItem.additions" style="padding:5px 0px;font-size:15px">
                            <div style="margin-top: 5px;font-size:15px;"
                              v-for="(gift, giftIndex) in ttp.storeItem.additions" :key="giftIndex">
                              {{ $t('other.a497') }}：{{ gift.skuName }}（{{ gift.cusCode }}） {{ $t('other.a567') }}：{{
                                gift.rate *
                                ttp.variationQuantityPurchased }}</div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="pic-box-desc-amount">
                            <span class="pic-box-desc-amount-item">sku： {{ ttp.storeItem ? ttp.storeItem.skuName :
                              ttp.variationSku ? ttp.variationSku : ttp.variationName }}</span>
                          </div>
                          <div class="pic-box-desc-amount">
                            <span class="pic-box-desc-amount-item">{{ $t('homeTwo.Specificationname') }}： {{ ttp.storeItem
                              ?
                              ttp.storeItem.variationName ? ttp.storeItem.variationName : description :
                              description }}</span>
                          </div>
                          <div class="pic-box-desc-amount">
                            <span>{{ $t('allorders.quantity') }}: x{{ ttp.variationQuantityPurchased }}</span>
                            <span style="margin-left:20px">{{ $t('homeTwo.Sellingprice') }}: {{ ttp.price ? ttp.price :
                              description }}</span>
                          </div>
                        </div>

                        <div class="pic-box-desc-amount">
                          <span>{{ $t('pendingorder.Inventory') }}:</span>
                          <span v-if="ttp.storeItem">
                            {{ $t('pendingorder.In_warehouse') }}:
                            {{ ttp.storeItem ? ttp.storeItem.storeNum :
                              '' }},{{ $t('pendingorder.committed') }}:{{ ttp.storeItem ? ttp.storeItem.unShipped :
    '' }},{{ $t('pendingorder.on_line') }}:{{ ttp.storeItem ? ttp.storeItem.stock : '' }}
                          </span>

                          <!-- <span style="color:red" v-if="ttp.storeItem &&ttp.storeItem.stock <= 0">（库存不足）</span> -->
                          <span style="color:red" v-if="!ttp.storeItem && ttp.itemKey !== 'DXS|EMPTY_ORDER'">{{
                            $t('allorders.Unboundproduct') }}</span>
                          <span class="bind" v-if="ttp.storeItem && item.platform !== 'DXS'"
                            @click="bindProduct(item, ttp)">{{ $t('allorders.relationship') }}</span>
                          <span class="bind" v-if="!ttp.storeItem && ttp.itemKey !== 'DXS|EMPTY_ORDER'"
                            @click="bindProduct(item, ttp)">{{ $t('allorders.Tobind') }}</span>
                          <span style="color:red" v-if="ttp.itemKey == 'DXS|EMPTY_ORDER'">{{ $t('allorders.emptyproducts')
                          }}</span>
                        </div>
                        <div class="pic-box-desc-amount" v-if="ttp.storeItem">
                          <span v-if="ttp.storeItem.putAway && !ttp.storeItem.component" class="oriderPutAway">{{
                            $t('other.a710') }}</span>
                          <span style="margin-left:20px"
                            v-if="ttp.storeItem.putAway && !ttp.storeItem.component && ttp.storeItem.children">{{
                              $t('other.a711') }}：{{ ttp.storeItem.children[0].userId }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="retrun-reasonr">
                    <div class="return-reasonr-desc">{{ $t('pendingorder.shopName') }}：{{ item.shopName }}</div>
                    <div class="return-reasonr-desc">
                      {{ $t('allorders.Platform') }}：
                      <span>{{ item.platform }}</span>
                    </div>
                    <div class="return-reasonr-desc">
                      {{ $t('homeTwo.Buyermessage') }}：
                      <span>{{ item.messageToSeller ? item.messageToSeller : description }}</span>
                    </div>
                    <div class="return-reasonr-desc">
                      {{ $t('homeTwo.Sellernotes') }}：
                      <span>{{ item.msgToStore ? item.msgToStore : description }}</span>
                    </div>
                  </div>
                  <div class="retrun-reasonr">
                    <div class="return-reasonr-desc">{{ $t('pendingorder.methods') }}：{{ item.logistics }}</div>
                    <!-- <div class="return-reasonr-desc">{{$t('pendingorder.actually_paid')}}：<span>({{item.currency}}){{item.totalAmount}}</span></div> -->
                    <div class="return-reasonr-desc">
                      {{ $t('pendingorder.waybill_number') }}：
                      <span>{{ trinkNumber(item.trackingNo) }}</span>
                    </div>
                    <div class="return-reasonr-desc">{{ $t('pendingorder.recipient') }}：{{ item.address.name }}</div>
                    <div class="return-reasonr-desc">{{ $t('pendingorder.phone') }}：{{ item.address.phone }}</div>
                  </div>
                  <div class="retrun-reasonr-btn">
                    <div>
                      <el-button style="min-width:150px;margin:3px 0" size="mini" type="primary"
                        @click="changeOrderInfo(item)">{{ $t('homeTwo.Modifyorderinformation') }}</el-button>
                    </div>
                    <div>
                      <el-button v-show="item.platform == 'DXS'" size="mini" style="min-width:150px;margin:3px 0"
                        type="primary" @click="deleteOrderInfo(item)">{{ $t('allorders.Deleteorder') }}</el-button>
                      <el-button v-show="item.platform !== 'DXS'" style="min-width:150px;margin:3px 0" size="mini"
                        type="primary" @click="showAndhidden(item)">{{ item.hidden ? $t('allorders.Accordingorder') :
                          $t('allorders.Hiddenorder') }}</el-button>
                    </div>
                    <div>
                      <el-button style="min-width:150px;margin:3px 0" size="mini" type="primary"
                        @click="updateEmptyBag(item)">{{ !item.emptyOrder ? $t('homeTwo.Setupanemptypackage') :
                          $t('allorders.Restoreorder') }}</el-button>
                    </div>
                    <div></div>
                  </div>
                </div>
                <div v-if="item.items.length > 3" style="text-align: center;border-top: 1px solid #eee;padding-top: 10px;"
                  @click="ttp01(index)">
                  <span style="margin-left: 15px; color: red;cursor: pointer;" v-if="active !== index">
                    <span class="iconfont icon-xia-down"></span>
                    {{ $t('allorders.Morehere') }}
                  </span>
                  <span style="margin-left: 15px; color: red;cursor: pointer;" v-else>
                    <span class="iconfont icon-xiala1"></span>
                    {{ $t('allorders.Hideup') }}
                  </span>
                </div>
              </div>
            </div>
            <!-- 分页器 -->
            <div class="Pager">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage1" :page-sizes="[15, 50, 100, 200]" :page-size="params.offset"
                layout=" total,sizes, prev, pager, next, jumper" :total="allCount"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from "../../../components/dialog/dialog.vue";
import CustomerOrder from "./components/dialog";
import utils from "../../../utils/utils.js";
import Condition from "../../../components/condition";

import order from "../../../api/moudles/order";
import userStoreItems from "../../../api/moudles/userStoreItems";
import { mapState, mapActions, mapMutations } from "vuex";
import api from "../../../api/api";
import newOrders from "../../../api/moudles/newOrders";
import jsonp from "../../../api/jsonp";

export default {
  data() {
    return {
      description: this.$t("allorders.description"),
      warehouselist: [], //所有仓库
      shopeeId: [], //所有商店
      shopeeIdvlue: "",
      loadingTip: 0,
      warehouseValue: "",
      value: "",
      errorList: [],
      userLimited: false,
      queryDate: "",
      showProListCopy: false,
      shopId: "",
      currentPage1: 1,
      dialogVisible: false,
      shophasAuthorization: JSON.parse(
        localStorage.getItem("shophasAuthorization")
      ),
      shopList: JSON.parse(localStorage.getItem("shopIdInfo")),
      warehouseList: JSON.parse(localStorage.getItem("warehouse")), //拿到当前帐号绑定的所有仓库
      allStoreIds: JSON.parse(localStorage.getItem("userInfo")).storeIds,
      allshoIdS: JSON.parse(localStorage.getItem("userInfo")).shopIds,
      isShopsooo: JSON.parse(localStorage.getItem("isShopsooo")),
      start_time: "",
      end_time: "",
      orderDetailDia: false,
      dialogVisible01: false,
      orderSn: "",
      orderShopid: "",
      scrollTop: 0,
      allShopInfo: [],
      bindError: false,
      timeValue: "",
      radio3: "",
      active: "",
      MassReview: [],
      checkedServiceTwo: false,
      storeType: false,
      checkedService: false,
      listData: [],
      goodsList: [],
      hidden: "1",
      value1: true,
      value2: true,
      multipleSelection: [],
      textDesc: null,
      goodsVisable: false,
      labelCCP: false,
      isReview: false,
      bindOrder: false,
      massCreateOrderDia: false,
      input10: "",
      showCustomerPop: false,
      radio7: "1",
      goodsType: null,
      bulletframe: false,
      checkBox: true,
      currentPage: 0, //当前页码
      offset: 200, //每页显示条数
      type: 1,
      checkall: false,
      isIndex: -1,
      activeName: "first",
      isShopee: true,
      mutilChoose: false,
      msg: "show time",
      sortType: 1,
      reviewSingle: "",
      autoAudit: false,
      value3: false,
      autoReviesList: [],
      bindParams: {},
      autoReviewWarehouse: null,
      success_data: [
        {
          fee: 0,
          msg: "15412",
          orderId: 25412414165
        }
      ],
      error_data: [
        {
          fee: 0,
          msg: "15412",
          orderId: 25412414165
        }
      ],
      isOpen: false,
      productfenlei: null,

      shopIdList: [],
      reloadorder: false,
      showAddFee: null,
      pickerOptions2: {
        shortcuts: [
          {
            text: this.$t("allorders.latestweek"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t("allorders.Lastmonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: this.$t("allorders.Lastthreemonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      ConditionOption: [
        {
          id: 0,
          desc: this.$t("allorders.regions"),
          isActive: 0,
          list: []
        },
        {
          id: 1,
          desc: this.$t("allorders.Platform"),
          isActive: 0,
          list: [
            {
              label: "SHOPEE",
              value: 0,
              active: false
            },
            {
              label: "LAZADA",
              value: 1,
              active: false
            },
            {
              label: this.$t("allorders.manualorder"),
              value: 3,
              active: false
            }
          ]
        },
        {
          id: 2,
          desc: this.$t("allorders.Sestore"),
          isActive: 0,
          list: []
        },
        {
          id: 3,
          desc: this.$t("allorders.orderscheduling"),
          isActive: 0,
          list: [
            {
              label: this.$t("homeTwo.Ordertimefromlatetoearly"),
              value: 0,
              active: false
            },
            {
              label: this.$t("homeTwo.Ordertimefrommorningtonight"),
              value: 1,
              active: false
            },
            {
              label: this.$t("homeTwo.Remainingdeliverytimefrommoretoless"),
              value: 2,
              active: false
            },
            {
              label: this.$t("homeTwo.Remainingdeliverytimefromlesstomore"),
              value: 3,
              active: false
            }
          ]
        },
        {
          id: 4,
          desc: this.$t("allorders.Themarks"),
          isActive: 0,
          list: [
            {
              label: this.$t("allorders.nomarks"),
              value: 0,
              active: false
            }
          ]
        }
      ],
      params: {
        end: null,
        start: null,
        orderId: null,
        hasStoreItem: true,
        orderType: 1,
        offset: 50,
        page: 0,
        hidden: false,
        shopIds: null,
        platformType: null,
        sortType: null,
        start: null,
        storeIds: null,
        userId: JSON.parse(localStorage.getItem("userInfo")).userId
      },
      goodsOption: [],
      dataParams: null,
      timer: null,
      showAppDia: false,
      synchronizeProductsStatus: 1,
      synchronizeProductsShow: false,
      synchronizeProductsArr: [],
      synchronizeProductsCheck: '',
      synchronizeProductsSKC: '',
    };
  },
  components: {
    Dialog,
    Condition,
    CustomerOrder
  },
  computed: {
    ...mapState({
      userId: state => state.shopaccess.userInfo.userId,
      orderlist: state => state.order.ax_unprocessOrder,
      warehouse: state => state.shopaccess.warehouse,
      isSuccess: state => state.order.isSuccess,
      pendingorderCounts: state => state.order.pendingorderCounts,
      deletReivewData: state => state.order.deletReivewData,
      lazadaorderlist: state => state.lazadaorders.lazadaorderlist,
      pendingOrderTotal_lazada: state =>
        state.lazadaorders.pendingOrderTotal_lazada,
      auditOrder_success: state => state.order.auditOrder_success,
      auditOrder_error: state => state.order.auditOrder_error,
      autoReives: state => state.order.autoReives,
      vipLevel: state => state.login.userInfo.vipLevel || "",
      flashPage: state => state.order.flashPage,
      storeItemsData: state => state.order.storeItemsData,
      allOrderList: state => state.order.allOrder,
      allCount: state => state.order.allCount,
      scrollLocation: state => state.common.scrollLocation
    }),
    orderListCopy() {
      let list1 = this.orderlist;
      if (this.storeItemsData) {
        list1.forEach(k => {
          k.items.forEach(p => {
            if (
              !p.storeItem ||
              p.storeItem == null ||
              p.storeItem == undefined
            ) {
              console.log(this.storeItemsData);
              p.storeItem = this.storeItemsData[p.itemId + "_" + p.variationId]
                ? this.storeItemsData[p.itemId + "_" + p.variationId]
                : undefined;
            }
          });
        });
      }
      return list1;
    },

    targetList() {
      let arr = this.allOrderList.filter(item => {
        return item.checked == true;
      });
      console.log("选中shopee订单", arr);
      return arr;
    },
    pendingorder() {
      return this.$t("pendingorder");
    }
  },
  inject: ["reload"],
  watch: {
    $router() {
      console.log("dksfnsd", $router);
    },
    msg(newValue) {
      console.log(newValue);
    },
    flashPage() {
      if (this.flashPage) {
        this.queryAllOrder(this.params);
      }
    },
    input10() {
      if (this.input10 === "") {
        this.handleCurrentChange();
      }
    },
    orderDetailDia() {
      if (!this.orderDetailDia) {
        this.queryAllOrder(this.params);
      }
    },
    dialogVisible01() {
      if (!this.dialogVisible01) {
        this.warehouseValue = "";
        this.MassReview = [];
        this.goodsType = null;
        this.checkall = false;
        this.allOrderList.forEach(p => {
          p.checked = false;
        });

        this.SET_ORDERLIST_NULL();
        this.reload();
      }
    },
    autoReives() {
      this.autoReives.forEach(p => {
        this.autoReviesList.forEach((k, index) => {
          if (p.shopId === k.shopId) {
            this.autoReviesList[index].isVerify = p.isVerify;
            this.autoReviesList[index].storeId = p.storeId;
            this.autoReviesList[index].userId = p.userId;
            this.autoReviesList[index].ruleId = p.ruleId;
            this.autoReviesList[index].isService = p.isService;
          }
        });
      });
    }
  },

  mounted() {
    setTimeout(() => {
      window.addEventListener("scroll", this.menu);
    }, 1000);
  },
  created() {
    this.init();
  },

  activated() {
    console.log("1激活activated钩子函数");
    document.documentElement.scrollTop = this.scrollLocation;
    this.queryAllOrder(this.params);
  },

  beforeRouteLeave(to, from, next) {
    //记录离开时的位置
    let position = window.scrollY;
    console.log("position", position);
    this.markScrollLocation(position);
    next();
  },
  methods: {
    ...mapActions("order", [
      "getPendingOrder", //获取所有店铺的待审核订单
      "auditOrder", //审核订单
      "getOrdersBytrickNo",
      "updatShopAllOrders",
      "reviewOrder",
      "getAutoreviewrules",
      "addAutoreviewrules",
      "delAutoreviewrules",
      "getSpeciesOrder",
      "getstoreitembyid",
      "getUnaditorOrder",
      "queryAllOrder",
      "getVarationsById"
    ]),
    ...mapActions("lazadaorders", ["getLazadaOrderByuserid"]),
    ...mapMutations("order", [
      "SET_ORDER_FINISH",
      "SET_ORDER_UNPAID",
      "READY_TO_SHIP",
      "ALL_ORDERS",
      "CANCELLED",
      "TO_RETURN",
      "TO_CONFIRM_RECEIVE",
      "SET_ORDERLIST_NULL",
      "GET_UNPROCESS_ORDER",
      "CHOOSE_SHOPID",
      "GO_TO_SEARCH_PENDING",
      "SUCCESS_GET_DATA_OPEN"
    ]),

    ...mapMutations("common", [
      "storageOrderInfo",
      "storageOrderInfoCopy",
      "markScrollLocation"
    ]),
    ...mapActions('mygoods', [
      'tongBuShopee',
    ]),


    menu() {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;

      this.scrollTop = scrollTop;
    },

    bindProduct(outerItem, item) {
      if (item.storeItem) {
        let storeName = item.storeItem.storeName;
        let itemSku = item.storeItem.itemSku;
        let skuName = item.storeItem.skuName;
        this.textDesc =
          this.$t('other.a734') +
          storeName +
          "/" +
          this.$t('other.a735') + ":" +
          itemSku +
          "/" + this.$t('other.a736') + ":" +
          skuName;
      } else {
        this.textDesc = this.$t('other.a737');
      }

      console.log(this.textDesc);
      console.log(item);
      (this.bindParams.itemKey = item.itemKey),
        (this.bindParams.shopId = outerItem.shopId),
        (this.bindParams.userId = this.userId);
      this.bindOrder = true;
      console.log(this.bindParams);
    },

    downLoadFiled() {
      api.downloadDxsOrderExcelFile().then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    updataItem(data) {
      console.log("data", data);
      this.bindParams.cusCode = Number(data[0].itemKey.split("|")[1]);
      console.log(this.bindParams);
      newOrders.bindByItemKey([this.bindParams]).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          if (res.data.error.length > 0) {
            // this.errorList = res.data.error;
            // this.bindError = true;
            this.tongBuShopee({
              shopId: sessionStorage.getItem('targetShopId'),
              userId: this.userId
            }).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: '首次绑定需要正在从平台同步信息，需稍后1分钟 再重试！谢谢',
                  type: 'warning',
                  duration: 10000
                });
                setTimeout(() => {
                  this.hideLoading()
                  this.$message.success(this.$t('other.a2405'))
                }, 10000)
              } else {
                this.$message.warning(res.msg)
              }
            })
          }
          if (res.data.error.length == 0) {
            this.$message.success(this.$t('other.a733'));
          }

          this.bindOrder = false;
          this.init();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    extportOrderInfo() {
      let arr = [];
      if (!this.targetList.length) {
        this.$message.warning(this.$t('other.a716'));
        return;
      }
      console.log(this.targetList);
      this.targetList.forEach(p => {
        p.items.forEach((k, index) => {
          k.totalSku = "";
          k.totalQty = 0;
          let num = index + 1;
          if (k.storeItem && k.storeItem.component) {
            //单品
            k.totalSku =
              "sku1" +
              ":" +
              k.storeItem.skuName +
              " */Qty:" +
              k.variationQuantityPurchased;
            k.totalQty = k.variationQuantityPurchased;
          } else {
            //套餐
            if (k.storeItem && k.storeItem.children) {
              k.storeItem.children.forEach((j, ttb) => {
                let vdf = ttb + 1;
                k.totalSku +=
                  "sku" +
                  vdf +
                  "(" +
                  j.cusCode +
                  ")" +
                  ":" +
                  j.skuName +
                  " */Qty:" +
                  k.variationQuantityPurchased * j.rate;
                k.totalQty += j.rate * k.variationQuantityPurchased;
              });
            }
          }

          arr.push({
            订单号: p.orderId,
            运单号: p.trackingNo,
            收货人: p.address.name,
            电话号码: p.address.phone,
            详细地址:
              p.address.state +
              "/" +
              p.address.city +
              "/" +
              p.address.fullAddress,
            产品名称: k.itemName,
            单品或套餐: k.storeItem
              ? k.storeItem.component
                ? this.$t('other.a251') + k.storeItem.cusCode
                : this.$t('other.a252') + k.storeItem.cusCode
              : "未绑定产品",
            sku详情: k.totalSku,
            sku数量: k.storeItem
              ? k.storeItem.component
                ? 1
                : k.storeItem.children.length
              : "未绑定产品",
            购买总数: k.totalQty,
            实收: k.price,
            配送方式: p.logistics,
            下单时间: utils.renderTime(p.createTime)
          });
        });
      });

      let list = [
        "订单号",
        "运单号",
        "收货人",
        "电话号码",
        "详细地址",
        "产品名称",
        "单品或套餐",
        "sku详情",
        "sku数量",
        "购买总数",
        "实收",
        "配送方式",
        "下单时间"
      ];
      console.log("arr", arr);
      utils.exPortEXml(arr, list, list);

      this.allOrderList.forEach(item => {
        item.checked = false;
      });
    },
    cnage() {
      console.log("1");

      setTimeout(function () {
        console.log("2");
        process.nextTick(function () {
          console.log("3");
        });
        new Promise(function (resolve) {
          console.log("4");
          resolve();
        }).then(function () {
          console.log("5");
        });
      });

      process.nextTick(function () {
        console.log("6");
      });

      new Promise(function (resolve) {
        console.log("7");
        resolve();
      }).then(function () {
        console.log("8");
      });

      setTimeout(function () {
        console.log("9");
        process.nextTick(function () {
          console.log("10");
        });
        new Promise(function (resolve) {
          console.log("11");
          resolve();
        }).then(function () {
          console.log("12");
        });
      });
    },
    resetOrder() {
      let obj = JSON.parse(JSON.stringify(this.params));
      obj.offset = this.allCount;
      if (obj.shopIds.length > 1) {
        this.$message.warning(this.$t('other.a792'));
        return;
      }
      this.$message.success(this.$t('other.a793'));
      order.getDistrustOrders(obj).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          res.data.orders.forEach(p => {
            newOrders
              .updateOriginal({
                orderId: p.orderId,
                userId: this.userId,
                shopId: p.shopId
              })
              .then(res => {
                if (res.code === 200) {
                } else {
                  this.$message.warning(res.msg);
                }
              });
          });
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    inPortXml(params) {
      this.loadingTip = 1;
      newOrders.massCreateOrder(params).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          this.loadingTip = 2;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    uploadFile(item) {
      console.log("item", item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("ordersFile", fileObj);
      form.append("userId", this.userId);
      console.log("form", form);
      this.inPortXml(form);
    },
    beforeUpload(file) {
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isTextComputer) {
        this.$message.warning(this.$t('other.a758'));
      }
      return isTextComputer;
    },
    // 上传文件个数超过定义的数量
    handleExceed(files, fileList) {
      console.log("123");
      this.$message.warning(this.$t('other.a759'));
    },

    createNewOrder() {
      this.$router.push({ path: "/createNewOrder" });
    },

    getUserLimte() {
      api
        .getUserAuditLimit({
          userId: this.userId
        })
        .then(res => {
          if (res.code === 200) {
            console.log("desc85", res.data);
            this.userLimited = res.data;
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    updataUserLimit() {
      this.userLimited = !this.userLimited;
      if (this.userLimited) {
        this.$confirm(this.$t('other.a770'), this.$t('other.a142'), {
          confirmButtonText: this.$t('other.a235'),
          cancelButtonText: this.$t('other.a146'),
          type: "warning"
        }).then(() => {
          this.updatauserLimitedCopy({
            auditLimit: false,
            userId: this.userId
          });
        });
      } else {
        this.$confirm(this.$t('other.a771'), this.$t('other.a142'), {
          confirmButtonText: this.$t('other.a235'),
          cancelButtonText: this.$t('other.a146'),
          type: "warning"
        }).then(() => {
          this.updatauserLimitedCopy({
            auditLimit: true,
            userId: this.userId
          });
        });
      }
    },

    updatauserLimitedCopy(params) {
      api.updateUserAuditLimit(params).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          if (res.data) {
            this.$message.success(this.$t('other.a772'));
          } else {
            this.$message.warning(this.$t('other.a773'));
          }

          this.getUserLimte();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    deleteOrderInfo(item) {
      this.$confirm(this.$t('other.a608'), this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      }).then(() => {
        newOrders.delDxsStoreItem(item).then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
            this.$message.success(this.$t('other.a565'));
            this.queryAllOrder(this.params);
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },

    updateEmptyBag(item) {
      console.log(item);
      let test = null;
      if (item.emptyOrder) {
        test = this.$t('other.a739');
      } else {
        test = this.$t('other.a740');
      }
      this.$confirm(test, this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      }).then(() => {
        newOrders
          .updateEmptyOrder({
            emptyOrder: !item.emptyOrder,
            userId: this.userId,
            orderId: item.orderId,
            shopId: item.shopId
          })
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('other.a741'));
              this.queryAllOrder(this.params);
            } else {
              this.message.warning(res.msg);
            }
          });
      });
    },

    showAndhidden(item) {
      let obj = {
        hidden: item.hidden,
        orderId: item.orderId,
        shopId: item.shopId,
        userId: this.userId
      };

      let text = null;

      if (item.hidden) {
        obj.hidden = false;
        text = this.$t('other.a742');
      } else {
        obj.hidden = true;

        text =
          this.$t('other.a743');
      }

      this.$confirm(text, this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      }).then(() => {
        order.hiddenOrder(obj).then(res => {
          if (res.code === 200) {
            if (item.hidden) {
              this.$message.success(this.$t('other.a744'));
              item.hidden = false;
            } else {
              this.$message.warning(this.$t('other.a745'));
              item.hidden = true;
            }

            this.queryAllOrder(this.params);
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },

    updataOrderItem(item) {
      console.log("55555555");
      console.log("item", item);
    },

    cancelGoodsType() {
      this.goodsType = -1;
      this.goodsVisable = false;
    },

    changeOrderInfo(item) {
      this.markScrollLocation(this.scrollTop);
      console.log(item);
      let orderItem = JSON.parse(JSON.stringify(item));
      let list = [];
      orderItem.items.forEach(p => {
        if (p.storeItem !== null) {
          p.itemKey = "DXS|" + p.storeItem.cusCode;
          list.push("DXS|" + p.storeItem.cusCode);
        }
      });
      newOrders.getItemByItemKey(list).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          orderItem.items.forEach(k => {
            if (k.storeItem) {
              let options = res.data[k.itemKey].storeItems.map(i => {
                return {
                  itemKey: "DXS|" + i.cusCode,
                  variationSku: i.skuName,
                  variationName: i.variationName,
                  image: i.image
                };
              });
              k.variationsCopy = options;
            }
          });
          this.storageOrderInfo(orderItem);
          this.storageOrderInfoCopy(orderItem);
          this.$router.push({
            path: "/changeOrderInfo"
          });
          console.log("852", orderItem);
        } else {
          this.$message.warning(res.msg);
        }
      });

      console.log("list", list);
    },

    getShopOrders(shopId) {
      console.log(shopId);
      this.shopeeIdvlue = shopId;
      this.handleCurrentChange();
    },

    getOrderParams(data) {
      console.log(data);
      if (data[0].list[data[0].isActive].value !== null) {
        this.ConditionOption[2].list = this.allShopInfo.filter(p => {
          if (p.code == data[0].list[data[0].isActive].value) {
            return p;
          }
        });
      } else {
        this.ConditionOption[2].list = this.allShopInfo;
      }

      this.currentPage1 = 1;
      this.params.page = 0;
      this.params.orderType = 1;
      this.params.country =
        data[0].isActive == 0 ? null : data[0].list[data[0].isActive].value;
      this.params.platform =
        data[1].isActive == 0
          ? ""
          : data[1].isActive == 3
            ? "DXS"
            : data[1].list[data[1].isActive].label;
      this.params.shopIds =
        data[2].isActive == 0
          ? this.allshoIdS
          : [data[2].list[data[2].isActive].value];
      this.params.sortType = data[3].list[data[3].isActive].value;

      console.log(this.params);
      this.queryAllOrder(this.params);
    },

    getOrderParamsCopy(data) {
      console.log("店铺多选", data);
      let shopIds = [];
      data[2].list.forEach(p => {
        if (p.active) {
          shopIds.push(p.value);
        }
      });
      this.currentPage1 = 1;
      this.params.page = 0;
      this.params.shopIds = shopIds;
      this.params.orderType = 1;
      this.params.sortType = data[3].list[data[3].isActive].value;
      this.queryAllOrder(this.params);
      console.log("shopIds", shopIds);
    },

    getHiddenOrder() {
      this.params.hidden =
        this.hidden == "null" ? null : this.hidden == "1" ? false : true;
      this.queryAllOrder(this.params);
    },

    showStoreNameById(id) {
      return utils.showstoreNameBystoreId(id);
    },

    // 判断是否是测品仓开启自动审核，是就弹窗提醒
    checkWarehouseType(StoreId) {
      this.warehouse.forEach(p => {
        if (p.storeId === StoreId) {
          this.storeType = p.storeType;
        }
      });
      if (this.storeType === 0) {
        this.$message.error(
          this.$t('other.a671')
        );
      }
    },
    // 系统取消订单的剩余时间
    cancelBySystem(time) {
      let timeStamp = Date.parse(new Date(time));
      timeStamp = timeStamp / 1000;
      timeStamp += Number(4) * 86400;
      let newTime = new Date(timeStamp * 1000);
      let d = new Date(newTime);
      let datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds();
      return utils.countTime(utils.renderTime(newTime));
    },

    // 产品分类拣货
    classification() {
      this.productfenlei = {
        shopId: this.shopeeIdvlue,
        type: this.type
      };
      this.getSpeciesOrder({
        shopId: this.shopeeIdvlue,
        type: this.type,
        userId: this.userId,
        offset: 15,
        page: 0
      });
      this.bulletframe = true;
    },
    // 向上向下隐藏
    ttp01(num) {
      if (this.active == num) {
        this.active = -1;
      } else {
        this.active = num;
      }
    },

    isAutoAudit() {
      this.autoAudit = false;
      this.getAutoreviewrules({ userId: this.userId });
    },

    saveAutoRevies(item) {
      if (!item.storeId) {
        this.$message.error(this.$t('other.a672'));
        return;
      }

      if (this.storeType === 0) {
        this.$message.error(
          this.$t('other.a671')
        );
        return;
      }

      this.autoReviesList.forEach(p => {
        if (p.shopId === item.shopId) {
          p.isOpen = true;
        }
      });
      console.log(item);
      this.addAutoreviewrules(item);
      this.getAutoreviewrules({ userId: this.userId });
    },
    closeAutoRevies(item) {
      this.delAutoreviewrules(item);
      this.autoReviesList.forEach(p => {
        if (p.shopId === item.shopId) {
          p.isOpen = false;
          p.ruleId = "";
          p.storeId = "";
          p.isVerify = false;
          p.isService = false;
        }
      });
      console.log(this.autoReviesList);
    },

    autoAuditrule() {
      let allShops = utils.getShopeeAndLazadaShopInfo();
      console.log(allShops);
      this.autoAudit = true;
      let arr = [];
      allShops.forEach(p => {
        let params = {
          shopId: p.value,
          shopName: p.label,
          isVerify: false,
          storeId: "",
          userId: this.userId,
          isOpen: false,
          ruleId: "",
          isService: false
        };
        arr.push(params);
        this.autoReviesList = arr;
      });
      console.log("warehouse", this.warehouse);
      let mmp = [];
      this.warehouse.forEach(item => {
        if (item.isUsed) {
          mmp.push({
            value: item.storeId,
            label: item.storeName,
            storeType: item.storeType
          });
        }
      });

      console.log("mmp", mmp);

      mmp.unshift({
        value: "",
        label: this.$t('other.a140')
      });
      this.autoReviewWarehouse = mmp;

      this.autoReives.forEach(p => {
        this.autoReviesList.forEach((k, index) => {
          if (p.shopId === k.shopId) {
            this.autoReviesList[index].isVerify = p.isVerify;
            this.autoReviesList[index].storeId = p.storeId;
            this.autoReviesList[index].userId = p.userId;
            this.autoReviesList[index].ruleId = p.ruleId;
            this.autoReviesList[index].isService = p.isService;
          }
        });
      });
    },

    tarGetAllServicd(num) {
      if (num == 0) {
        this.auditOrder_success.forEach(p => (p.service = this.checkedService));
      }

      if (num == 1) {
        this.auditOrder_error.forEach(
          p => (p.service = this.checkedServiceTwo)
        );
      }
    },

    cancelReview() {
      this.dialogVisible01 = false;
      this.checkall = false;
      this.allOrderList.forEach(p => {
        p.checked = false;
      });

      this.SET_ORDERLIST_NULL();
      this.reload();
    },

    searchOrder() {
      this.params.orderId =
        this.params.orderId == ""
          ? null
          : this.params.orderId.replace(/\s*/g, "");
      this.queryAllOrder(this.params);
    },
    getTime(item) {
      return utils.renderTime(item);
    },
    getTime01(time) {
      return utils.renderTime(time);
    },
    getStatus(item) {
      let ttp = utils.conversionStatus(item);
      return ttp;
    },
    submitGoods() {
      this.goodsVisable = false;
    },

    //初始化商店，仓库
    init() {
      this.ConditionOption = [
        {
          id: 0,
          desc: this.$t("allorders.regions"),
          isActive: 0,
          list: []
        },
        {
          id: 1,
          desc: this.$t("allorders.Platform"),
          isActive: 0,
          list: [
            {
              label: "SHOPEE",
              value: 0,
              active: false
            },
            {
              label: "LAZADA",
              value: 1,
              active: false
            },
            {
              label: this.$t("allorders.manualorder"),
              value: 3,
              active: false
            }
          ]
        },
        {
          id: 2,
          desc: this.$t("allorders.Sestore"),
          isActive: 0,
          list: []
        },
        {
          id: 3,
          desc: this.$t("allorders.orderscheduling"),
          isActive: 0,
          list: [
            {
              label: this.$t("homeTwo.Ordertimefromlatetoearly"),
              value: 0,
              active: false
            },
            {
              label: this.$t("homeTwo.Ordertimefrommorningtonight"),
              value: 1,
              active: false
            },
            {
              label: this.$t("homeTwo.Remainingdeliverytimefrommoretoless"),
              value: 2,
              active: false
            },
            {
              label: this.$t("homeTwo.Remainingdeliverytimefromlesstomore"),
              value: 3,
              active: false
            }
          ]
        },
        {
          id: 4,
          desc: this.$t("allorders.Themarks"),
          isActive: 0,
          list: [
            {
              label: this.$t("allorders.nomarks"),
              value: 0,
              active: false
            }
          ]
        }
      ];

      let countryList = utils.getCountryCodeByUser();
      countryList.forEach(p => {
        this.ConditionOption[0].list.push({
          label: utils.conutryConversion(p),
          value: p,
          active: false
        });
      });

      let lazadaShops = JSON.parse(localStorage.getItem("userInfo"))
        .lazadaShops;
      let shopeeShops = JSON.parse(localStorage.getItem("userInfo"))
        .shopeeShops;

      if (lazadaShops !== null && lazadaShops.length > 0) {
        lazadaShops.forEach(p => {
          this.shopeeId.push({
            label: p.name + "(" + p.country + ")",
            value: p.sellerId,
            active: false
          });
          this.ConditionOption[2].list.push({
            label:
              p.name +
              "(" +
              utils.conutryConversion(p.country.toUpperCase()) +
              ")",
            country: utils.conutryConversionCopy(p.country.toUpperCase()),
            code: p.country.toUpperCase(),
            value: p.sellerId,
            active: false
          });
        });
      }

      if (shopeeShops !== null && shopeeShops.length > 0) {
        shopeeShops.forEach((p, index) => {
          this.shopeeId.push({
            label: p.shopName + "(" + p.country + ")",
            value: p.shopId,
            active: false
          });

          this.ConditionOption[2].list.push({
            label: p.shopName + "(" + utils.conutryConversion(p.country) + ")",
            country: utils.conutryConversionCopy(p.country.toUpperCase()),
            value: p.shopId,
            code: p.country.toUpperCase(),
            active: false
          });
        });
      }

      this.ConditionOption[2].list.sort((a, b) => {
        console.log(a.country);
        return a.country - b.country;
      });

      this.allShopInfo = this.ConditionOption[2].list;
      console.log("allShopInfo", this.shopeeId);
      this.warehouselist = utils.getAllwarehouse().slice(1); //获取当前帐号下所有仓库
      console.log("warse", this.warehouselist);
      this.warehouseValue =
        this.warehouselist.length > 0 ? this.warehouselist[0].value : null;
      this.shopeeIdvlue = this.shopeeId.length ? this.shopeeId[0].value : null;
      this.params.orderType = 1;

      this.timeValue = [
        utils.getRecentSevenDay(-30),
        utils.getRecentSevenDay(1)
      ];
      this.shopIdList = this.shopeeId.map(p => {
        return p.value;
      });

      this.ConditionOption[1].list.unshift({
        label: this.$t("allorders.all"),
        value: null
      });
      this.ConditionOption[2].list.unshift({
        label: this.$t("allorders.all"),
        value: null
      });
      this.ConditionOption[0].list.unshift({
        label: this.$t("allorders.all"),
        value: null,
        active: false
      });

      this.params.shopIds = JSON.parse(
        localStorage.getItem("userInfo")
      ).shopIds;
      this.params.storeIds = this.allStoreIds;
      //    this.params.start=this.timeValue[0]
      //    this.params.end=this.timeValue[1]
      this.params.sortType = this.ConditionOption[3].list[0].value;
      this.params.platform = "";

      this.shopIdList.splice(0, 1);
      this.queryAllOrder(this.params);
      // this.handleCurrentChange()
      this.getAutoreviewrules({ userId: this.userId });
    },
    //订单筛选
    choice(num) {
      this.ALL_ORDERS(num);
    },

    trinkNumber(num) {
      if (num) {
        return num;
      } else {
        return this.pendingorder.notgenerated;
      }
    },
    changeImgURL(url) {
      // let baseUrl="https://s-cf-th.shopeesz.com/"
      // let index=url.indexOf("/file/")
      // let ttp=url.slice(index)
      // return baseUrl+ttp
      return url;
    },

    checkAll() {
      if (!this.checkall) {
        this.allOrderList.forEach(p => {
          p.checked = false;
        });
      } else {
        let newArray = this.allOrderList.filter(item => {
          return (item.checked = true);
        });
        this.allOrderList = newArray;
        console.log(newArray);
      }
    },
    //审核订单商品
    Review() {
      console.log(this.warehouseValue);
      utils.setDefalultStoreId(this.warehouseValue);
      this.goodsVisable = utils.judgeTestStore(this.warehouseValue);
      console.log(this.goodsVisable);
      this.dataParams.storeId = this.warehouseValue;
      let store = JSON.parse(localStorage.getItem("userInfo")).stores;
      console.log(store);
      this.storeType = store.find(
        item => item.storeId === this.warehouseValue
      ).storeType;
      console.log("storeType", this.storeType);

      if (this.goodsVisable) {
        this.goodsOption = utils.getChargeRuleBystoreId(this.warehouseValue);
        this.auditOrder({
          payload: this.dataParams,
          text: this.pendingorder.Successful_review
        });
      } else {
        this.goodsType = null;
        this.auditOrder({
          payload: this.dataParams,
          text: this.pendingorder.Successful_review
        });
      }
    },
    //点击批量审核选中要审核的订单数据
    commitRevies() {
      console.log(this.targetList);
      if (!this.targetList.length) {
        this.$message.error(this.$t('other.a794'));
        return;
      }
      let defaultStoreId = utils.getDefalultStoreId();
      console.log("defaultStoreId", defaultStoreId);

      let storeOptions = this.warehouse.filter(p => {
        if (p.isUsed) {
          return p;
        }
      });
      let ttp = storeOptions.some(p => p.storeId == defaultStoreId);
      if (defaultStoreId && ttp) {
        this.warehouseValue = defaultStoreId;
      } else {
        this.warehouseValue = storeOptions[0].storeId;
      }

      console.log("warehouseValue", this.warehouseValue);

      let store = JSON.parse(localStorage.getItem("userInfo")).stores;
      console.log(store);
      this.storeType = store.find(
        item => item.storeId == this.warehouseValue
      ).storeType;
      console.log(this.storeType);

      this.goodsVisable = utils.judgeTestStore(this.warehouseValue);
      if (this.goodsVisable) {
        //测品仓时
        this.goodsOption = utils.getChargeRuleBystoreId(this.warehouseValue);
      } else {
        //其它类型仓
      }

      this.MassReview = this.allOrderList.filter(item => {
        return item.checked === true;
      });

      let list = this.MassReview.map(p => {
        return p.orderId;
      });

      this.dataParams = {
        orderIds: list,
        storeId: this.warehouseValue,
        userId: this.userId,
        partnerId: JSON.parse(localStorage.getItem("userInfo")).partnerId
      };

      this.auditOrder({
        payload: this.dataParams,
        text: this.pendingorder.Successful_review
      });

      this.dialogVisible01 = true;

      console.log("defaultStoreId", defaultStoreId);
      console.log("warehouse", this.warehouse);
      console.log("ttp", ttp);
      console.log("storeOptions", storeOptions);
    },
    // 审核通过订单
    revieworders(num) {
      if (!this.warehouseValue) {
        this.$message.error(this.$t('other.a795'));
        return;
      }
      if (this.goodsVisable) {
        //审核的仓库是测品仓
        if (this.goodsType == null) {
          this.$message.warning(this.$t('other.a796'));
          return;
        }
      }
      if (num == 0) {
        //审核通过现货订单
        let arr = this.auditOrder_success.map(p => {
          return {
            goodsType: this.goodsVisable ? this.goodsType : -1,
            orderId: p.orderId,
            shopId: p.shopId,
            storeId: this.warehouseValue,
            service: p.service,
            userId: this.userId,
            platform: p.platform
          };
        });

        console.log(arr);

        if (!arr.length) {
          this.$message.warning(this.$t('other.a797'));
          return;
        }
        this.reviewOrder(arr).then(res => {
          if (res.code === 200) {
            this.success_data = res.data.success;
            this.error_data = res.data.errors;
            this.orderDetailDia = true;
          } else {
            this.$message.warning(res.msg);
          }
        });
        this.dialogVisible01 = false;
        this.checkall = false;
        this.allOrderList.forEach(p => {
          p.checked = false;
        });
      } else if (num === 1) {
        //审核通过全部
        let arr = this.auditOrder_success.map(p => {
          return {
            goodsType: this.goodsVisable ? this.goodsType : -1,
            orderId: p.orderId,
            shopId: p.shopId,
            storeId: this.warehouseValue,
            service: p.service,
            userId: this.userId,
            platform: p.platform
          };
        });

        let arr1 = this.auditOrder_error.map(p => {
          return {
            goodsType: this.goodsVisable ? this.goodsType : -1,
            orderId: p.orderId,
            shopId: p.shopId,
            storeId: this.warehouseValue,
            service: p.service,
            userId: this.userId,
            platform: p.platform
          };
        });
        arr1.forEach(k => {
          arr.push(k);
        });
        console.log(arr);
        this.reviewOrder(arr).then(res => {
          if (res.code === 200) {
            this.success_data = res.data.success;
            this.error_data = res.data.errors;
            this.orderDetailDia = true;
          }
        });
        this.dialogVisible01 = false;
        this.checkall = false;
        this.allOrderList.forEach(p => {
          p.checked = false;
        });
      }
    },
    gotosearch() {
      if (!this.input10) {
        this.$message({
          message: this.$t("unprocessedorder").searchContent,
          type: "warning"
        });
        return;
      }
      const params = {
        type: this.type,
        orders: this.input10
      };
      let obj = this.orderListCopy.map(p => {
        if (p.ordersn == this.input10) {
          return {
            itemId: p.itemId,
            variationId: p.variationId
          };
        }
      });

      this.getOrdersBytrickNo(params);
    },
    //剩余发货时间
    countTime(item) {
      if (!item.shipByDate) {
        return this.$t('other.a354');
      }
      let lasttime = utils.renderTime(item.shipByDate);

      let day = "";
      let hour = "";
      let minute = "";
      let second = "";
      const end = Date.parse(new Date(lasttime));
      const now = Date.parse(new Date());

      if (now >= end) {
        day = 0;
        hour = 0;
        minute = 0;
        second = 0;
        return "0";
      }

      const msec = end - now;
      let d = parseInt(msec / 1000 / 60 / 60 / 24); //算出天数
      let h = parseInt((msec / 1000 / 60 / 60) % 24); //算出小时数
      let m = parseInt((msec / 1000 / 60) % 60); //算出分钟数
      let s = parseInt((msec / 1000) % 60); //算出秒数

      day = d;
      hour = h > 9 ? h : "0" + h;
      minute = m > 9 ? m : "0" + m;
      second = s > 9 ? s : "0" + s;
      const that = this;

      return (
        day +
        this.$t("pendingorder.day") +
        hour +
        this.$t("pendingorder.hours") +
        minute +
        "分"
      );
    },

    //控制每页显示订单条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.offset = parseInt(`${val}`);
      this.params.offset = parseInt(`${val}`);
      this.handleCurrentChange();
    },
    //显示当前第几页
    handleCurrentChange(val) {
      this.currentPage1 = parseInt(`${val}`);
      this.params.page = parseInt(`${val}`)
        ? (parseInt(`${val}`) - 1) * this.params.offset
        : 0;
      this.queryAllOrder(this.params);
    },

    choiceshopId(num) {
      this.sortType = num;
      this.handleCurrentChange();
    },

    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    //同步订单状态
    Synchronize(num) {
      let start_time = "";
      let end_time = "";
      if (num === 0) {
        start_time = this.getDay(-3);
        end_time = this.getDay(0);
      } else if (num === 1) {
        start_time = this.getDay(-7);
        end_time = this.getDay(0);
      } else if (num === 2) {
        start_time = this.getDay(-30);
        end_time = this.getDay(0);
      } else if (num === 3) {
        start_time = this.getDay(-90);
        end_time = this.getDay(0);
      }


      if (!this.shopeeIdvlue) {
        const arr = {
          end: end_time,
          start: start_time,
          shopIds: this.params.shopIds,
          userId: this.userId
        };

        this.$message.warning(this.$t('other.a798'));
        setTimeout(() => {
          this.updatShopAllOrders({ payload: arr, text: this.shopeeIdvlue });
        }, 1000);
      } else {
        const arr = {
          end: end_time,
          start: start_time,
          shopIds: this.params.shopIds,
          userId: this.userId
        };

        this.$message.warning(this.$t('other.a798'));

        setTimeout(() => {
          this.updatShopAllOrders({ payload: arr, text: this.shopeeIdvlue });
        }, 1000);
      }

    },

    synchronizeProductsOpen(index) {
      this.synchronizeProductsStatus = index;
      this.synchronizeProductsArr = utils.getAllshop();
      if(this.synchronizeProductsArr.length>0){
        this.synchronizeProductsArr.shift();
      }
      this.synchronizeProductsSKC = '';
      this.synchronizeProductsCheck = this.synchronizeProductsArr.length > 0 ? this.synchronizeProductsArr[0].value : '';
      this.synchronizeProductsShow = true;
    },
    synchronizeProducts() {
      //同步商品
      if (this.synchronizeProductsCheck == '') {
        this.$message.warning('请选择店铺！')
        return
      }
      if (this.synchronizeProductsStatus == 2 && this.synchronizeProductsSKC == '') {
        this.$message.warning('请输入SKCID！')
        return
      }
      let data = {}
      if (this.synchronizeProductsStatus == 1) {
        data = {
          shopId: this.synchronizeProductsCheck,
          userId: this.userId,
        }
      } else {
        let lines = this.synchronizeProductsSKC.split(/\r?\n/);
        data = {
          shopId: this.synchronizeProductsCheck,
          userId: this.userId,
          skcList: lines
        }
      }
      const loading = this.$loading({
        lock: true,
        text: '同步中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.tongBuShopee(data).then(res => {
        loading.close();
        if (res.code === 200) {
          this.$message.success(this.$t('other.a2405'))
          this.synchronizeProductsShow = false;
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        loading.close();
      })
    },
  }
};
</script>

<style>
/* .pendingorder {
		flex: 1;
		position: relative;
		margin: 60px 0 0 235px;
		
	} */

.pendingorder .order-list-item {
  position: relative;
  padding-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.colng {
  display: flex;
  align-items: center;
  margin-left: 30px;
  font-size: 18px;
  cursor: pointer;
  color: #f56c6c;
}

.pendingorder .order-title {
  border-bottom: 1px #e0e0e0 solid;
}

.pendingorder .el-icon-loading {
  font-size: 18px;
}

.pendingorder .massCreateWrapper {
  text-align: center;
  margin: 20px 0;
}

.pendingorder .el-icon-upload {
  font-size: 75px;
  color: #409eff;
}

.pendingorder .modleDownload {
  color: red;
  cursor: pointer;
}

.pendingorder .masscreateTip {
  margin-top: 20px;
  color: red;
  text-align: center;
  font-size: 14px;
}

.pendingorder .bind {
  color: #409eff;
  margin-left: 20px;
  cursor: pointer;
}

.pendingorder .order-query {
  display: flex;
  justify-content: start;

  padding: 10px 10px 10px 0;
  border-bottom: 1px #e0e0e0 solid;
}

.pendingorder .order-title {}

.img-box {
  display: flex;
}

.pendingorder .order-query .query {
  position: relative;
  margin-right: 30px;
}

.pendingorder .list-btn {
  padding: 20px 15px;
}

.pendingorder .order-title-count {
  color: red;
  font-style: inherit;
  margin-left: 10px;
}

.pendingorder .orderDetailDia {
  display: flex;
  justify-content: space-between;
}

.pendingorder .list-desc-item {
  font-size: 14px;

  padding-right: 15px;
}

.pendingorder .list-item-status {
  color: red;
}

.pendingorder .didan {
  font-size: 24px;
}

.pendingorder .icon-tuihuo2 {
  color: red;
  font-size: 25px;
  margin-right: 10px;
}

.pendingorder .list-content {
  display: flex;
  align-items: center;
}

.pendingorder .order-pic {
  display: flex;
  align-items: center;
  width: 150px !important;
  height: 150px !important;
}

img {
  width: 100%;
}

.pendingorder .list-content-left,
.list-content-right {
  display: flex;
}

.pendingorder .commitRevies {
  margin-left: 15px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
}

.commitRevies:hover {
  color: #409eff;
}

.pendingorder .list-item-wrapper {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 15px;
}

.pendingorder .order-selec {
  width: 150px;
  margin: 0 10px;
}

.pendingorder .order-desc {
  padding-left: 30px;
}

.pendingorder .order-title-desc {
  margin-bottom: 15px;
}

.pendingorder .list-price-item,
.shoper-name {
  margin: 20px;
  padding: 2px 0;
}

.pendingorder .list-number,
.list-price {
  margin-left: 40px;
}

.pendingorder .primary-btn {
  display: inline-block;
  margin: 0 30px;
}

.icon-gouSolid-copy,
.icon-jinggao {
  font-size: 20px;
  padding: 0 10px;
}

.icon-sign {
  color: red;
  margin-right: 5px;
  cursor: pointer;
}

/* 	.loading{
		position: absolute;
		right: 0;
		top: 180px;
		width: 80%;
		
	} */

.pendingorder .search-box {
  width: 60px;
}

.pendingorder .nodata {
  margin-top: 100px;
  text-align: center;
  color: #000;
}

.pendingorder .ilnkg {
  color: #909399;
  padding: 20px;
  font-weight: bold;
}

.pendingorder .okng {
  font-size: 63px;
  margin-bottom: 30px;
  color: #909399;
}

.pendingorder .chekbox {
  width: 30px;
  height: 30px;
}

.pendingorder .lknvkf {
  background-image: url(../../../assets/img/reviewed.png);
  background-size: 10%;
  background-position: 30%;
  background-repeat: no-repeat;
}

.pendingorder .second-menu {
  display: flex;
  justify-content: space-between;
}

.pendingorder .menu-right-btn {
  margin-right: 30px;
}

.pendingorder .second-menu-left {
  flex: 1;
  display: flex;
}

.pendingorder .checkallbox-left {
  display: flex;
}

.pendingorder .search-box {
  width: 100px;
  margin: 0 10px 0px 10px;
}

.pendingorder .sousuo-box {
  width: 400px;
}

.pic-box-desc-amount {
  box-sizing: border-box;
  padding: 3px 0;
}

.pendingorder .Pager {
  position: fixed;
  bottom: 0;
  left: 205px;
  right: 0;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: right;
}

.pendingorder .dsce-box {
  display: flex;
}

.pendingorder .desc-wrpper {
  display: flex;
  flex-direction: column;
  width: 50%;
}

.pendingorder .list-shoper-box {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 50%;
  box-sizing: border-box;
  padding: 15px;
}

.pendingorder .operate {
  margin-top: 50px;
  margin-right: 30px;
}

.pendingorder .checkallbox {
  display: flex;
  align-items: center;
  box-sizing: border-box;

  padding: 10px;
  justify-content: space-between;
}

.pendingorder .allOrder {
  margin-right: 10px;
}

.pendingorder .order-count {
  margin-top: 10px;
}

.pendingorder .el-dropdown-link {
  color: #606266;
}

/* 新起点 */

.list-desc {
  display: flex;
  align-items: center;
  margin-left: 15px;
  border-bottom: 1px #eee solid;
}

.pendingorder .chekbox {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.pendingorder .reviveOrder {
  display: flex;
  justify-content: space-between;
}

.pendingorder .pic-box {
  display: flex;
  flex-direction: column;
  margin: 2px;
  width: 80px;
  height: 80px;
}

.pendingorder .oriderPutAway {
  color: #fff;
  font-weight: 550;
  display: inline-block;
  background-color: #67c23a;
  text-align: center;
  border-radius: 8px;
  margin: 5px 0;
  box-sizing: border-box;
  padding: 2px 10px;
}

.pendingorder .return-item {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px;
}

.pendingorder .return-item-list {
  display: flex;
  align-items: center;
  margin: 5px 0;
  border-bottom: 1px solid #eee;
}

.pendingorder .unfold:nth-of-type(n + 4) {
  display: none;
}

.pendingorder .pic-box-desc {
  width: 400px;
  margin-left: 20px;
}

.pendingorder .retrun-reasonr {
  margin-left: 30px;
}

.pendingorder .retrun-reasonr-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}

.pendingorder .seller {
  margin-right: 10px;
  font-size: 18px;
}

.pendingorder .return-reasonr-desc {
  box-sizing: border-box;
  padding: 3px 0;
}

.pendingorder .seller-item {
  margin-left: 15px;
  font-size: 14px;
}

.pendingorder .seller-ppc {
  color: red;
}

.pendingorder .country-choose {
  width: 200px;
}

.pendingorder .btn-box {
  margin-top: 10px;
  display: flex;
}
</style>
